module.exports = __webpack_public_path__ + "img/post_box.af9cb880.svg";